export default "__VITE_ASSET__DEe_CyjR__"